import React from 'react';
import { Text, DefaultButton, Stack, getTheme } from '@fluentui/react';

export interface SelectionItemProps {
  title: string;
  category: string;
  key: string;
  onClick(): void;
}

export const SelectionItem: React.FunctionComponent<SelectionItemProps> = props => {
  const { palette } = getTheme();
  const bgColor: React.CSSProperties = {
    backgroundColor: palette.themeLighterAlt
  };

  return (
    <Stack horizontal className="pl-3 justify-content-center align-self-center" style={bgColor}>
      <Stack.Item className="justify-content-center align-self-center">
        {props.category !== props.title && props.category !== 'Default' ? (
          <Text variant="mediumPlus">{props.category + ' > ' + props.title}</Text>
        ) : (
          <Text variant="mediumPlus">{props.title}</Text>
        )}
      </Stack.Item>
      <Stack.Item grow disableShrink>
        <div></div>
      </Stack.Item>
      <Stack.Item>
        <DefaultButton
          className="ms-bgColor-themeLighterAlt ms-borderColor-themeLighterAlt"
          onClick={(): void => props.onClick()}
          iconProps={{ iconName: 'Cancel' }}
        />
      </Stack.Item>
    </Stack>
  );
};
